
import React from 'react';
import { UserRoundPlus } from 'lucide-react';

export const UserPlusIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <UserRoundPlus strokeWidth={1.5} {...props} />
);
